import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { GET_ORGANIZATIONS } from '../types';
import { getOrganizationsPending, getOrganizationsFulfilled, getOrganizationsRejected } from '../actions/getOrganizationsActions';
import { sendApiRequest, notifyWarning, notifyError } from '../actions';
import generateError from '../utilities/generateError';
import { ORGANIZATION_MESSAGES } from '../constants/organizationMessages';

const createPayload = payload => ({
  method: 'get',
  url: 'organization/get?isActive=true',
  onSuccess: [response => (response.data.length === 0 ? notifyWarning(ORGANIZATION_MESSAGES.NOT_FOUND) : getOrganizationsFulfilled(response))],
  onError: [
    getOrganizationsRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'ajaxApiNoAuthorize',
};

const getOrganizationsEpic$ = action$ => action$.pipe(
  ofType(GET_ORGANIZATIONS.DEFAULT),
  mergeMap(({ payload }) => merge(
    of(getOrganizationsPending()),
    of(sendApiRequest(createPayload(payload), meta)),
  )),
);

export default getOrganizationsEpic$;


// WEBPACK FOOTER //
// ./src/epics/getOrganizationsEpic.js